import styled from "styled-components"

import { Box } from "../grid"
import { BaseContainer } from "../container"
import { devices } from "../../utils/styleVariables"

const HeroContainer = styled(BaseContainer)`
  flex-direction: column;

  @media ${devices.mobile} {
    flex-direction: row;
  }

  ${props => {
    const { margin: propsMargin } = props
    if (!propsMargin)
      return "@media" + devices.tablet + "{margin: 100px auto !important;}"
    return Object.keys(propsMargin).reduce((acc, m) => {
      const calculatedMargin = "margin:" + propsMargin[m] + " !important;"
      if (m === "base") return acc + calculatedMargin
      if (propsMargin[m] !== null)
        return acc + "@media" + devices[m] + "{" + calculatedMargin + ";}"
      return acc
    }, "")
  }}
`

const TextContainer = styled.div`
  line-height: 1.6;
`

const Column = styled(Box)`
  width: 100%;

  @media ${devices.mobile} {
    padding: 5px;
    width: ${props => (props.span / 12) * 100}%;
  }
`

export { HeroContainer, TextContainer, Column }
